export default {
	namespaced: true,
	state: {
		permissions: [],
	},

	mutations:{
		/**
		 * [setPermissions description]
		 * @param {[type]} state   [description]
		 * @param {[type]} payload [description]
		 */
		setPermissions(state, payload) {
			state.permissions = payload
		},

		/**
		 * [addPermission description]
		 * @param {[type]} state   [description]
		 * @param {[type]} payload [description]
		 */
		addPermission(state, payload) {
			state.permissions.push(payload)
		},

		/**
		 * [updatePermission description]
		 * @param  {[type]} state   [description]
		 * @param  {[type]} payload [description]
		 * @return {[type]}         [description]
		 */
		updatePermission(state, payload) {
			for (let i=0; i<state.permissions.length; i++) {
				if(state.permissions[i].id==payload.id) {
					state.permissions[i]=payload
					break
				}
			}
		},

		/**
		 * [removePermission description]
		 * @param  {[type]} state   [description]
		 * @param  {[type]} payload [description]
		 * @return {[type]}         [description]
		 */
		removePermission(state, permission_id) {
			for (let i=0; i<state.permissions.length; i++) {
				if(state.permissions[i].id==permission_id) {
					state.permissions.splice(i, 1);
					break
				}
			}
		}
	},
	getters:{
		/**
		 * [permissions description]
		 * @param  {[type]} state [description]
		 * @return {[type]}       [description]
		 */
		permissions(state) {
			return state.permissions
		}
	},
	actions: {

	},

}